import sv from '@drawbotics/drylus-style-vars';
import { Color, Flex, FlexAlign, FlexItem, List, ListItem } from '@drawbotics/react-drylus';
import { css } from 'emotion';

import { PasswordErrors, createTranslate } from '~/utils';

const tt = createTranslate('routes.sign_up.password_validation');

const styles = {
  passwordValidation: css`
    margin-left: calc(${sv.marginSmall} * -1);
  `,
};

export const PasswordValidation = (props: { error?: Array<string> }) => {
  return (
    <div className={styles.passwordValidation}>
      <Flex align={FlexAlign.START}>
        <FlexItem flex>
          <List>
            <ListItem
              color={
                props.error?.includes(PasswordErrors.LOWERCASE_CHARACTER) ? Color.RED : Color.GREEN
              }>
              {tt('one_lowercase_char')}
            </ListItem>
            <ListItem
              color={
                props.error?.includes(PasswordErrors.UPPERCASE_CHARACTER) ? Color.RED : Color.GREEN
              }>
              {tt('one_uppercase_char')}
            </ListItem>
            <ListItem
              color={props.error?.includes(PasswordErrors.LENGTH) ? Color.RED : Color.GREEN}>
              {tt('length')}
            </ListItem>
          </List>
        </FlexItem>
        <FlexItem flex>
          <List>
            <ListItem
              color={props.error?.includes(PasswordErrors.NUMBER) ? Color.RED : Color.GREEN}>
              {tt('number')}
            </ListItem>
          </List>
        </FlexItem>
      </Flex>
    </div>
  );
};
